
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 12.167v-5.75L10 10.5l-9.167-5L10 .5l9.167 5v6.667H17.5zM10 15.5l-5.833-3.167V8.167L10 11.333l5.833-3.166v4.166L10 15.5z"}})])
          )
        }
      }
    